/**
 * Ingredients accordion: only one <details> open at a time per list.
 * Toggles blur on PDP mobile ingredient carousel when an item is expanded.
 */
function syncIngredientCarouselBlur(accordion) {
  const carousel = accordion.closest('.locale-ingredients-carousel--product, .locale-ingredients-carousel--home');
  if (!carousel) return;

  const hasOpen = accordion.querySelector('details.accordion__item[open]');
  carousel.classList.toggle('is-ingredient-open', Boolean(hasOpen));
}

function initIngredientsAccordions(root = document) {
  root.querySelectorAll('.ingredients-accordion').forEach((accordion) => {
    if (accordion.dataset.ingredientsSingleOpenReady === 'true') return;

    const items = [...accordion.querySelectorAll('details.accordion__item')];
    if (items.length === 0) return;

    accordion.dataset.ingredientsSingleOpenReady = 'true';
    syncIngredientCarouselBlur(accordion);

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) {
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        }

        syncIngredientCarouselBlur(accordion);
      });
    });
  });
}

function initAll() {
  initIngredientsAccordions();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', initAll);

if (typeof window !== 'undefined') {
  window.initIngredientsAccordions = initIngredientsAccordions;
}
